import type { OTCDealData } from '@src/types/OTC';
import { getOtcDealQuantityDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import { InspectorNumberDisplay } from './InspectorNumberDisplay';

interface QuantityDisplayProps {
  instrumentData: OTCDealData;
}

export const QuantityDisplay = ({ instrumentData }: QuantityDisplayProps) => {
  const { value, currency } = getOtcDealQuantityDisplayValue(instrumentData);
  return <InspectorNumberDisplay value={value} currency={currency} showDashIfEmpty={false} />;
};
